var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomePeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 684.95 684.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2, .cls-3 {\n        fill: #5c5cff;\n      }\n\n      .cls-4 {\n        fill: #fad4a1;\n        mix-blend-mode: overlay;\n      }\n\n      .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-3, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15 {\n        stroke-width: 0px;\n      }\n\n      .cls-16 {\n        isolation: isolate;\n      }\n\n      .cls-5 {\n        fill: #f7ffff;\n      }\n\n      .cls-6 {\n        fill: #f2ebf0;\n      }\n\n      .cls-7 {\n        fill: #604e75;\n      }\n\n      .cls-8 {\n        fill: #5d57d8;\n      }\n\n      .cls-9 {\n        fill: #2c2334;\n      }\n\n      .cls-10 {\n        fill: #cb715e;\n      }\n\n      .cls-11 {\n        fill: #dac9d4;\n      }\n\n      .cls-12 {\n        fill: #84b9ff;\n      }\n\n      .cls-13 {\n        fill: #f69363;\n      }\n\n      .cls-14 {\n        fill: #00a295;\n      }\n\n      .cls-15 {\n        fill: blue;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 342.47,
    cy: 342.47,
    r: 342.47
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 342.47,
    cy: 342.47,
    r: 342.47
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 156.87,
    cy: 198.34,
    r: 27.2,
    transform: "translate(-64.33 320.88) rotate(-80.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m94.13,318.61h0c-11.61-2.54-23.09,4.81-25.63,16.42l-22.53,78.92,33.55,5.35,31.04-75.05c2.54-11.61-4.81-23.09-16.42-25.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m59.86,458.25c1.47,0,2.91-.74,3.75-2.08,1.28-2.06.65-4.77-1.41-6.05-.17-.11-7.48-4.9-8.42-13.28-1.08-9.65,1.98-19.18,2.01-19.27.76-2.31-.5-4.8-2.81-5.56-2.31-.76-4.79.5-5.56,2.8-.15.46-3.7,11.4-2.4,23.01,1.43,12.77,12.07,19.49,12.52,19.77.72.45,1.52.66,2.32.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m57.93,446.96h0c2.7-.32,4.63-2.77,4.31-5.46l-2.33-19.68c-.32-2.7-2.77-4.63-5.46-4.31h0c-2.7.32-4.63,2.77-4.31,5.46l2.33,19.68c.32,2.7,2.77,4.63,5.46,4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m55.46,459.23c1.47,0,2.91-.74,3.75-2.08,1.28-2.06.65-4.77-1.41-6.05-.17-.11-7.48-4.9-8.42-13.28-1.08-9.65,1.98-19.18,2.01-19.27.76-2.31-.5-4.8-2.81-5.56-2.31-.76-4.79.5-5.56,2.8-.15.46-3.7,11.4-2.4,23.01,1.43,12.77,12.07,19.49,12.52,19.77.72.45,1.52.66,2.32.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m55.92,433.02s0-3.47-4.29-4.51c-4.29-1.05-6.88,4.13-6.88,4.13,0,0-4.02-9.09-1.85-16.44,1.09-3.69,4.49-7.46,4.49-7.46l16.3,3.8s3.74,14.92-7.76,20.48Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m75.01,367.52h63.43l-5.14,109.67H55.81c2.64-41.89,8.31-81.85,19.19-109.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m111.05,367.52h57.12s21.04,35.31,29.21,70.83c2.46,10.67,4.46,24,6.1,38.84h-81.73l-10.7-109.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m106.64,173.44c-6.41,8.64-13.65,14.12-16.18,12.25-2.52-1.87.62-10.39,7.03-19.03,6.41-8.64,13.65-14.12,16.18-12.25,2.52,1.87-.62,10.39-7.03,19.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m106.24,183.09c-6.41,8.64-13.65,14.12-16.18,12.25-2.52-1.87.62-10.39,7.03-19.03,6.41-8.64,13.65-14.12,16.18-12.25,2.52,1.87-.62,10.39-7.03,19.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 121.55,
    cy: 182.38,
    r: 25.49,
    transform: "translate(-93.36 139.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m128.84,209.44l-15.65,4.76c-11.7,2.39-22.14-7.73-20.12-19.5l3.77-18.62,35.44-1.2-3.45,34.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m106.09,158.45s8.15,15.12,16.02,22.01c7.86,6.89,18.09,10.47,18.09,10.47l6.84-3.67s6.62-21.33-12.33-29.73c-18.95-8.4-30.39-3.81-28.61.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "149.31 232.7 124.54 232.7 114.47 189.48 139.24 189.48 149.31 232.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m148.6,198.57c-3.98,4.22-9.67,5.32-12.71,2.45-3.04-2.87-2.28-8.61,1.7-12.83,3.98-4.22,9.67-5.32,12.71-2.45,3.04,2.87,2.28,8.61-1.7,12.83Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 127.71,
    cy: 180.34,
    rx: 5.69,
    ry: 19.47,
    transform: "translate(-61.39 66) rotate(-23.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m141.33,193.23l-1.19-.87c3.15-4.35,7.78-4.05,7.98-4.04l-.11,1.47c-.16-.01-4.02-.23-6.67,3.43Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 119.58,
    y: 210.51,
    width: 6.16,
    height: 1.48,
    transform: "translate(-59.88 48.92) rotate(-18.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m105.4,200.78c-1.31,0-2.28-.12-2.35-.12l.18-1.46s2.11.25,4.2,0c2.02-.24,4.06-1.49,4.08-1.5l.77,1.26c-.09.06-2.34,1.43-4.68,1.71-.77.09-1.54.12-2.21.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m103.28,193.78c-.45-.69-1.48-2.4-1.25-3.39.06-.29.25-.53.51-.69.61-.36,1.76-.23,2.62-.05l.41-2.52,1.46.24-.67,4.12-.79-.22c-.76-.21-1.63-.34-2.07-.33.12.44.54,1.3,1.01,2.03l-1.23.81Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 113.24,
    cy: 186.4,
    rx: 1.18,
    ry: 2.18
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 101.87,
    cy: 186.4,
    rx: 1.18,
    ry: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m139.95,203.42c-.33,0-.67-.02-1-.08l.24-1.46c1.26.21,2.85-.22,2.86-.23l.39,1.42c-.06.02-1.22.34-2.5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m112.11,174.02c9.61,6.93,19.05,10.27,21.08,7.47,2.03-2.8-4.12-10.69-13.73-17.62-9.61-6.93-19.05-10.27-21.08-7.47-2.03,2.8,4.12,10.69,13.73,17.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m75.01,367.51h93.18l4.87-111.8c.55-14.34-10.93-26.27-25.28-26.27h-35.56c-9.33,0-15.05,4.96-22.3,13.35l-22.59,28.42c-6.27,11.7-6.63,25.68-.97,37.69h0c2.15,4.56,3.46,9.48,3.87,14.51l4.77,44.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m215.23,359.06h0c10.29-5.95,13.81-19.11,7.86-29.41l-51.04-88.31c-5.95-10.29-19.11-13.81-29.41-7.86h0c-10.29,5.95-13.81,19.11-7.86,29.41l51.04,88.31c5.95,10.29,19.11,13.81,29.41,7.86Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m173.41,448.55l5.95-18.34c.78-2.42-.54-5.02-2.96-5.8h0c-2.42-.78-5.02.54-5.8,2.96l-5.95,18.34c-.78,2.42.54,5.02,2.96,5.8h0c2.42.78,5.02-.54,5.8-2.96Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 172.35,
    y: 417.72,
    width: 30.55,
    height: 34.34,
    transform: "translate(637 285.26) rotate(94.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m176.36,465.67l2.96-34.38-8.57-.74-2.96,34.38c-.2,2.37,1.55,4.45,3.91,4.65h0c2.37.2,4.45-1.55,4.65-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m184.55,470.86l2.96-34.38-8.57-.74-2.96,34.38c-.2,2.37,1.55,4.45,3.91,4.65h0c2.37.2,4.45-1.55,4.65-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m193.38,468.48l2.96-34.38-8.57-.74-2.96,34.38c-.2,2.37,1.55,4.45,3.91,4.65h0c2.37.2,4.45-1.55,4.65-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m202.54,462.31l2.96-34.38-8.57-.74-2.96,34.38c-.2,2.37,1.55,4.45,3.91,4.65h0c2.37.2,4.45-1.55,4.65-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m207.51,319.42h0c-11.84-1.02-22.27,7.76-23.29,19.6l-12.4,79.18,34.22,2.95,21.07-78.44c1.02-11.84-7.76-22.27-19.6-23.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "177.07 465.73 178.64 447.54 177.22 447.42 175.65 465.6 177.07 465.73"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 175.16,
    y: 457.14,
    width: 21.06,
    height: 1.42,
    transform: "translate(-286.01 604.86) rotate(-85.23)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "194.68 461.64 195.84 448.17 194.42 448.04 193.27 461.51 194.68 461.64"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 163.02,
    y: 300.02,
    width: 2.21,
    height: 25.57,
    transform: "translate(-130.82 118.39) rotate(-28.92)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "116.64 434.99 105.71 433.1 106.11 430.78 118.8 432.98 123.05 477.19 120.7 477.19 116.64 434.99"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m144.92,172.82c-1.16-5.67-4.31-11.68-11.87-15.3-7.45-3.56-13.63-4.78-18.16-4.65,4.91-.17,11.67,1.04,19.82,4.65,7.78,3.45,11.21,9.07,12.6,14.5-.81.23-1.61.49-2.38.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m172.35,384.28c-4.7-10.24-8.29-16.76-8.29-16.76h.01s1.75-43.4,1.75-43.4l.06-.04,3.88,7.25-1.58,36.17h-.02s2.11,3.55,5.23,9.48l-1.06,7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m109.18,214.53c-9.62-.33-17.33-8.87-16.2-18.84.43-.02.91-.14,1.44-.35-1.25,10.04,5.84,18.73,14.76,19.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m99.39,156.4c-.88,1.31-.09,3.72,1.88,6.63-.9,1.13-1.8,2.34-2.69,3.63-5.94,8.64-8.85,17.16-6.51,19.03.2.16.45.25.71.3-1.97,4.59-2.51,8.21-1.09,9.35.14.11.3.19.47.25-.87.2-1.59.14-2.1-.25-1.54-1.14-.95-4.76,1.17-9.35-.29-.05-.55-.14-.77-.3-2.52-1.87.62-10.39,7.03-19.03.96-1.29,1.93-2.49,2.9-3.63-2.13-2.9-2.98-5.32-2.03-6.63.55-.75,1.64-1.05,3.12-.96-.96.06-1.7.36-2.1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m113.13,214.2l6.06-1.99.05.15-6.04,1.84c-.32.07-.64.09-.96.13.3-.05.59-.07.89-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m156.87,225.54c-.59,0-1.17-.04-1.76-.08,13.2-.86,23.67-12.65,23.67-27.12s-10.48-26.28-23.69-27.12c.59-.04,1.18-.08,1.78-.08,15.02,0,27.2,12.18,27.2,27.2s-12.18,27.2-27.2,27.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m106.58,156.51c-.13-.05-.25-.09-.37-.13.69-1.48,2.78-2.71,6.03-3.24-3.11.54-5.08,1.83-5.66,3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m195.28,464.21c.32-.56.55-1.2.6-1.9l2.74-34.38h-.04s.54-6.78.54-6.78l19.52-78.44c.53-6.7-1.84-12.95-5.99-17.29l-45.01-84.07c-3.3-6.16-8.99-9.86-15.06-10.6-2.11-.76-4.36-1.19-6.7-1.27l-1.24-5.73c.91.37,1.84.67,2.79.93l1.12,4.8c2.52.08,4.95.51,7.23,1.27,6.56.73,12.71,4.44,16.26,10.6l48.59,84.07c4.48,4.35,7.04,10.59,6.46,17.29l-21.07,78.44-.58,6.78h.04s-2.96,34.39-2.96,34.39c-.06.7-.3,1.34-.65,1.9.56,4.16,1.09,8.5,1.58,12.97h-6.72c-.46-4.47-.94-8.81-1.47-12.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m57.19,458.84c-.55.24-1.13.39-1.73.39-.79,0-1.59-.21-2.32-.66-.45-.28-11.08-7.01-12.52-19.77-1.18-10.54,1.63-20.5,2.27-22.6,0,0,0,0,0,0h0c.06-.21.11-.37.13-.41.03-.1.09-.18.12-.28,1.27-3.45,4.24-6.77,4.24-6.77h.06s21.05-73.71,21.05-73.71c.48-2.19,1.28-4.23,2.34-6.08l-.6-5.54c-.41-5.03-1.72-9.94-3.87-14.51-5.66-12.01-5.31-25.99.97-37.69l22.59-28.42c7.25-8.39,12.98-13.35,22.3-13.35h0c-8.64,0-13.94,4.96-20.66,13.35l-20.93,28.42c-5.81,11.7-6.14,25.68-.9,37.69,1.99,4.56,3.21,9.48,3.59,14.51l.56,5.54c-.98,1.85-1.72,3.89-2.17,6.08l-19.5,73.72h-.06s-2.75,3.3-3.93,6.75c-.04.09-.08.18-.12.28-.01.04-.06.2-.12.41h0s0,0,0,0c-.59,2.09-3.2,12.05-2.1,22.6,1.33,12.77,11.18,19.49,11.6,19.77.67.45,1.41.66,2.15.66.56,0,1.1-.15,1.61-.39-.49,6.05-.9,12.18-1.26,18.35h-4.16c.39-6.17.84-12.3,1.36-18.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "508.1 220.28 557.74 220.28 549.9 173.97 511.62 173.97 508.1 220.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m648.71,318.96h0c6.03-10.62,2.31-24.12-8.32-30.15l-91.14-51.74c-10.62-6.03-24.12-2.31-30.15,8.32h0c-6.03,10.62-2.31,24.12,8.32,30.15l91.14,51.74c10.62,6.03,24.12,2.31,30.15-8.32Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 552.5,
    y: 371.52,
    width: 31.38,
    height: 35.29,
    transform: "translate(1198 110.52) rotate(121.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m543.61,412.17l18.65-30.16-7.51-4.65-18.65,30.16c-1.28,2.07-.64,4.8,1.43,6.08h0c2.07,1.28,4.8.64,6.08-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m548.71,420.72l18.65-30.16-7.51-4.65-18.65,30.16c-1.28,2.07-.64,4.8,1.43,6.08h0c2.07,1.28,4.8.64,6.08-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m557.92,422.63l18.65-30.16-7.51-4.65-18.65,30.16c-1.28,2.07-.64,4.8,1.43,6.08h0c2.07,1.28,4.8.64,6.08-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m569.17,421.22l18.65-30.16-7.51-4.65-18.65,30.16c-1.28,2.07-.64,4.8,1.43,6.08h0c2.07,1.28,4.8.64,6.08-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m639.94,292.49h0c-10.39-6.42-24.02-3.21-30.44,7.18l-48.06,66.87,37.62,23.26,48.06-66.87c6.42-10.39,3.21-24.02-7.18-30.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 539.17,
    y: 403.46,
    width: 18.75,
    height: 1.46,
    transform: "translate(-83.91 657.72) rotate(-58.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 544.97,
    y: 408.6,
    width: 21.63,
    height: 1.46,
    transform: "translate(-83.78 668.94) rotate(-58.46)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 558.36,
    y: 409.94,
    width: 13.9,
    height: 1.46,
    transform: "translate(-81.47 675.04) rotate(-58.23)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 597.09,
    y: 311.34,
    width: 8.97,
    height: 2.27,
    transform: "translate(19.24 659.5) rotate(-58.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m482.13,375.81l-30.05-4.67c-2.58-.4-4.35-2.82-3.95-5.4h0c.4-2.58,2.82-4.35,5.4-3.95l30.05,4.67c2.58.4,4.35,2.82,3.95,5.4h0c-.4,2.58-2.82,4.35-5.4,3.95Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m501.19,370.62h65.17c10.66,27.22,16.45,65.77,19.32,106.57h-79.49l-5-106.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m440.64,443.39c8.39-36.5,29.98-72.77,29.98-72.77h58.7l-10.4,106.57h-83.83c1.54-12.8,3.38-24.32,5.56-33.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m483.28,367.76l1.7,1.7c-.36.36-33.48,34.41-40.97,107.72h-2.42c7.54-74.41,41.32-109.06,41.69-109.43Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 520.73,
    cy: 183.24,
    r: 24.59,
    transform: "translate(-22.63 85.78) rotate(-9.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m513.69,209.34l15.1,4.59c11.29,2.3,21.36-7.46,19.41-18.82l-3.64-17.97-34.2-1.16,3.33,33.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "493.94 231.78 517.84 231.78 527.55 190.09 503.66 190.09 493.94 231.78"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 499.94,
    cy: 193.85,
    rx: 7.3,
    ry: 10.14,
    transform: "translate(3.17 395.68) rotate(-43.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m501.64,193.7l1.15-.83c-3.04-4.19-7.5-3.91-7.7-3.89l.1,1.42c.15-.01,3.88-.22,6.44,3.31Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 518.94,
    y: 208.11,
    width: 1.42,
    height: 5.94,
    transform: "translate(156.74 638.74) rotate(-71.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m536.31,200.98c1.26,0,2.2-.11,2.26-.12l-.17-1.41s-2.04.24-4.05,0c-1.95-.23-3.92-1.43-3.94-1.45l-.75,1.21c.09.06,2.25,1.38,4.51,1.65.74.09,1.48.12,2.13.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m538.35,194.24c.44-.66,1.42-2.31,1.21-3.27-.06-.28-.24-.51-.5-.67-.59-.35-1.69-.22-2.53-.05l-.4-2.43-1.4.23.65,3.97.77-.21c.74-.2,1.58-.33,1.99-.31-.11.43-.52,1.26-.98,1.96l1.19.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m527.6,187.12c0,1.16.51,2.1,1.14,2.1s1.14-.94,1.14-2.1-.51-2.1-1.14-2.1-1.14.94-1.14,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m538.57,187.12c0,1.16.51,2.1,1.14,2.1s1.14-.94,1.14-2.1-.51-2.1-1.14-2.1-1.14.94-1.14,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m502.97,203.54c.32,0,.65-.02.97-.07l-.23-1.4c-1.22.2-2.75-.21-2.76-.22l-.38,1.37c.06.02,1.18.32,2.41.32Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m566.36,370.62h-95.74l-5.01-114.86c-.57-14.74,11.23-27,25.98-27h36.53c9.58,0,15.46,5.1,22.91,13.72l23.21,29.2c6.44,12.02,6.81,26.39.99,38.73h0c-2.21,4.69-3.56,9.74-3.98,14.91l-4.91,45.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m497.02,228.76s21.57,42.97,25.04,59.33c3.47,16.37,1.89,82.53,1.89,82.53h35.75s3.29-67.46,3.45-85.25c.17-17.79-38.53-56.61-38.53-56.61h-27.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "521.92 435.64 541.01 430.62 541.63 432.94 524.16 437.55 520.25 477.19 517.82 477.19 521.92 435.64"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m374.44,315.15h0c-6.03-10.62-2.31-24.12,8.32-30.15l91.14-51.74c10.62-6.03,24.12-2.31,30.15,8.32h0c6.03,10.62,2.31,24.12-8.32,30.15l-91.14,51.74c-10.62,6.03-24.12,2.31-30.15-8.32Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 439.26,
    y: 367.71,
    width: 31.38,
    height: 35.29,
    transform: "translate(543.47 -204.26) rotate(58.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m479.53,408.36l-18.65-30.16,7.51-4.65,18.65,30.16c1.28,2.07.64,4.8-1.43,6.08h0c-2.07,1.28-4.8.64-6.08-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m561.37,405.32l12.11-27.96,8.08,3.57-12.11,27.96c-.99,2.23-3.59,3.24-5.82,2.26h0c-2.23-.99-3.24-3.59-2.26-5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m571.92,413.21l13.32-31.97,7.54,4.66-12.76,30.82c-.97,2.24-3.57,3.27-5.81,2.29h0c-2.24-.97-3.27-3.57-2.29-5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m565.37,415.64l12.11-27.96,8.08,3.57-12.11,27.96c-.99,2.23-3.59,3.24-5.82,2.26h0c-2.23-.99-3.24-3.59-2.26-5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m474.44,416.91l-18.65-30.16,7.51-4.65,18.65,30.16c1.28,2.07.64,4.8-1.43,6.08h0c-2.07,1.28-4.8.64-6.08-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m465.23,418.82l-18.65-30.16,7.51-4.65,18.65,30.16c1.28,2.07.64,4.8-1.43,6.08h0c-2.07,1.28-4.8.64-6.08-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m453.98,417.42l-18.65-30.16,7.51-4.65,18.65,30.16c1.28,2.07.64,4.8-1.43,6.08h0c-2.07,1.28-4.8.64-6.08-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m383.21,288.68h0c10.39-6.42,24.02-3.21,30.44,7.18l48.06,66.87-37.62,23.26-48.06-66.87c-6.42-10.39-3.21-24.02,7.18-30.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 473.87,
    y: 391.01,
    width: 1.46,
    height: 18.76,
    transform: "translate(-139.63 309.45) rotate(-31.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 466.63,
    y: 394.71,
    width: 1.46,
    height: 21.63,
    transform: "translate(-143.14 304.67) rotate(-31.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 457.11,
    y: 399.92,
    width: 1.46,
    height: 13.89,
    transform: "translate(-145.56 301.67) rotate(-31.74)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 420.44,
    y: 304.19,
    width: 2.27,
    height: 8.97,
    transform: "translate(-99.34 267.96) rotate(-31.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 552.22,
    y: 354.06,
    width: 30.97,
    height: 2.26,
    transform: "translate(164.23 889.67) rotate(-84.98)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "467.46 289.08 466.35 287.11 478.5 280.21 479.62 282.18 467.46 289.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "568.2 410.96 566.85 410.38 574.84 391.92 576.19 392.5 568.2 410.96"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 568.19,
    y: 408.73,
    width: 18.3,
    height: 1.46,
    transform: "translate(-15.18 796.64) rotate(-68.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m513.28,220.28v-38.77l37.3.06-.37-6.48c-2.08-15.92-15.64-27.83-31.69-27.83h0c-15.26,0-28.38,10.78-31.35,25.74l-9.38,47.27h35.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m578.75,304.3l-2.21-.51c.04-.16,3.57-15.81.05-25.03-3.57-9.33-26.59-33.25-26.83-33.49l1.63-1.58c.96,1,23.58,24.49,27.31,34.26,3.77,9.86.2,25.67.04,26.34Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m440.64,443.39c2.48-10.79,6.12-21.55,10-31.36l-15.32-24.77.04-.02-1.51-2.45,5.27-3.5,3.42,5.95-.04.02,14.25,24.77c-3.62,9.82-7,20.58-9.31,31.36-2.03,9.47-3.73,21.01-5.16,33.8h-7.19c1.54-12.79,3.37-24.32,5.55-33.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m387.32,319.12c-1.07-1.86-1.84-3.83-2.35-5.84-4.31-10.29-.7-22.6,8.61-28.28l84.82-51.74c2.47-1.51,5.11-2.4,7.76-2.74,2.7-1.12,5.63-1.77,8.71-1.77h2.84l1.84-8.48h-2.93l-1.97,8.48h-3.05c-3.31,0-6.45.65-9.36,1.77-2.85.33-5.68,1.23-8.34,2.74l-91.14,51.74c-10.01,5.68-13.88,17.99-9.26,28.28.55,2.01,1.38,3.98,2.53,5.84l48.06,66.87,5.63-3.48-42.4-63.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m473.69,373.75l-.33-.05.19.32c.05-.09.09-.18.14-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m490.74,173.01c2.72-14.72,14.58-25.36,28.48-25.71-.24,0-.47-.03-.71-.03-15.26,0-28.38,10.78-31.35,25.74l-9.38,47.27h4.23l8.73-47.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m549.42,175.09l.05.99,6.96,44.2h1.31l-7.47-44.2-.06-.99c-1.08-8.3-5.3-15.48-11.35-20.48,5.63,5,9.56,12.19,10.56,20.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "472.02 288.33 471.89 288.09 467.15 290.99 470.32 363.61 475.1 364.4 472.02 288.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m576.07,418.31c.46-.42.84-.94,1.1-1.58l11.88-30.82,2.93,1.95-11.96,28.87c-.27.63-.69,1.15-1.18,1.58,3.19,18.28,5.37,38.3,6.83,58.88h-3.25c-1.35-20.59-3.39-40.61-6.35-58.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m569.05,352.81l1.13-12.95-.49-.04,1.57-14.52c.42-5.17,1.76-10.22,3.98-14.91h0c.77-1.63,1.37-3.32,1.9-5.02l-2.19-1.34h-.06c-.58,2.15-1.27,4.28-2.18,6.35h0c-2.06,4.69-3.31,9.74-3.7,14.91l-1.46,14.52.45.04-1.34,16.51,2.38-3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m640.39,288.81l-91.14-51.74c-1.82-1.03-3.72-1.76-5.66-2.23-1.55-1.32-3.11-2.42-4.74-3.33,1.52.91,2.97,2.01,4.41,3.33,1.8.47,3.57,1.2,5.27,2.23l84.82,51.74c9.31,5.68,12.92,17.99,8.61,28.28-.51,2.01-1.28,3.98-2.35,5.84l-43.5,65.04,2.95,1.83,48.06-66.87c1.15-1.86,1.98-3.83,2.53-5.84,4.63-10.29.75-22.6-9.26-28.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m425.3,471.13c-1.7,0-3.37-.86-4.33-2.41-1.48-2.38-.75-5.51,1.62-7,.19-.13,8.65-5.66,9.73-15.35,1.25-11.15-2.29-22.17-2.32-22.28-.87-2.67.58-5.54,3.25-6.42,2.67-.88,5.54.57,6.42,3.24.17.53,4.28,13.17,2.77,26.59-1.66,14.75-13.95,22.53-14.47,22.85-.84.52-1.76.76-2.68.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m415.45,469.77c-1.7,0-3.37-.86-4.33-2.41-1.48-2.38-.75-5.51,1.62-7,.19-.13,8.65-5.66,9.73-15.35,1.25-11.15-2.29-22.17-2.32-22.28-.87-2.67.58-5.54,3.25-6.42,2.67-.88,5.54.57,6.42,3.24.17.53,4.28,13.17,2.77,26.59-1.66,14.76-13.95,22.53-14.47,22.85-.84.52-1.76.76-2.68.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m405.6,468.41c-1.7,0-3.37-.86-4.33-2.41-1.48-2.38-.75-5.51,1.62-7,.19-.13,8.65-5.66,9.73-15.35,1.25-11.15-2.29-22.17-2.32-22.28-.87-2.67.58-5.54,3.25-6.42,2.67-.88,5.54.57,6.42,3.24.17.53,4.28,13.17,2.77,26.59-1.66,14.75-13.95,22.53-14.47,22.85-.84.52-1.76.76-2.68.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m427.53,458.07h0c-3.12-.37-5.35-3.2-4.98-6.31l2.7-22.74c.37-3.12,3.2-5.35,6.31-4.98h0c3.12.37,5.35,3.2,4.98,6.31l-2.7,22.74c-.37,3.12-3.2,5.35-6.31,4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m430.38,472.25c-1.7,0-3.37-.86-4.33-2.41-1.48-2.38-.75-5.51,1.62-7,.19-.13,8.65-5.66,9.73-15.35,1.25-11.15-2.29-22.17-2.32-22.28-.87-2.67.58-5.54,3.25-6.42,2.67-.88,5.54.57,6.42,3.24.18.53,4.28,13.17,2.77,26.59-1.66,14.75-13.95,22.53-14.47,22.85-.84.52-1.76.76-2.68.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m429.85,441.97s0-4.01,4.96-5.22c4.96-1.21,7.96,4.77,7.96,4.77,0,0,4.64-10.5,2.14-19-1.26-4.26-5.19-8.62-5.19-8.62l-18.84,4.39s-4.33,17.24,8.97,23.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m385.69,304.63h0c13.42-2.94,26.68,5.56,29.62,18.98l26.04,91.2-29.56,7.6-45.08-88.16c-2.94-13.42,5.56-26.68,18.98-29.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m318.95,346.3h89.59c4.68,36.04,6.7,83.03,7.26,130.89h-90.71l-6.14-130.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m246.77,428.15c4-48.35,9.29-81.85,9.29-81.85h94.53l-12.77,130.89h-94.21c.99-18.69,2.05-35.56,3.17-49.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "342.26 419.44 363.74 413.78 364.43 416.4 344.78 421.58 339.29 477.19 336.57 477.19 342.26 419.44"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m335.3,173.93h0c48.03,0,87.03,39,87.03,87.03v134.54h-174.06v-134.54c0-48.03,39-87.03,87.03-87.03Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 349.98,
    cy: 118.27,
    r: 30.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m341.17,150.95l18.9,5.75c14.13,2.88,26.75-9.34,24.31-23.56l-4.56-22.5-42.82-1.45,4.17,41.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m373.75,98.7s-22.79-2.39-29.71,5.14c-4.52,4.92,3.81,13.73-.86,16.64-11.82,7.38-20.7,8.09-20.7,8.09l-8-6.46s-3.56-29.94,22.99-36.78c26.55-6.84,36.3,8.52,36.27,13.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "318.18 173.96 354 186.51 367.89 126.84 328.61 126.84 318.18 173.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m354.72,138.61l2.82,11.11,27.92-1.13-3.56-13.91c-.66-2.57-3.06-4.3-5.71-4.1l-16.58,1.23c-3.39.25-5.74,3.51-4.9,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m331.44,126.33s.9,23.39,1.55,25.41c.65,2.02,31.8,20.01,45.79,11.1,13.98-8.91,4.94-32.92,4.94-32.92,0,0,3.45,14.99-13.17,14.66-16.62-.33-32.23-7.72-35.29-21.45l-3.83,3.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 323.77,
    cy: 130.23,
    rx: 8.61,
    ry: 11.95,
    transform: "translate(-20.01 190.22) rotate(-31.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m325.78,130.46c-2.13-4.68-6.48-5.31-6.66-5.34l.21-1.66c.22.03,5.45.75,7.98,6.31l-1.53.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m369.49,140.49c-.82,0-1.74-.04-2.67-.15-2.83-.34-5.54-1.99-5.65-2.06l.93-1.52s2.5,1.52,4.93,1.81c2.52.3,5.05,0,5.08,0l.22,1.77c-.07,0-1.25.15-2.83.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m372.05,132.04l-1.49-.98c.57-.88,1.08-1.91,1.22-2.45-.52-.02-1.57.14-2.49.39l-.96.27-.81-4.97,1.76-.29.5,3.04c1.05-.22,2.43-.38,3.17.06.32.19.54.49.62.84.27,1.19-.97,3.26-1.51,4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m358.59,123.13c0,1.45.64,2.63,1.43,2.63s1.43-1.18,1.43-2.63h-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m372.32,123.13c0,1.45.64,2.63,1.43,2.63s1.43-1.18,1.43-2.63h-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m326.38,143.08c-1.04,0-1.85-.13-1.9-.14l.29-1.76s1.97.32,3.46-.1l.48,1.72c-.77.21-1.61.28-2.33.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m299.34,232.3c-1.42,4.26-3.95,8.24-7.55,11.45l-4.62,4.06-59.28,52.43-30.66,27.07c-11.03,9.73-27.83,8.71-37.56-2.32-9.75-10.98-8.71-27.83,2.28-37.58l80.48-71.13,14.09-12.43c3.01-2.67,6.43-4.51,10.04-5.56,9.65-2.88,20.46-.14,27.52,7.87,6.54,7.38,8.21,17.36,5.28,26.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 194.7,
    y: 296.25,
    width: 72.47,
    height: 2.55,
    transform: "translate(-139.12 227.42) rotate(-41.46)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "237.09 428.02 219.06 397.64 256.83 376.02 274.86 406.4 237.09 428.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m274.99,427.95l-20.3-34.19,9.45-5.41,20.21,34.05c1.48,2.5.63,5.73-1.89,7.17l-.42.24c-2.47,1.41-5.61.58-7.06-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m268.17,437.81l-20.3-34.19,9.45-5.41,20.21,34.05c1.48,2.5.63,5.73-1.89,7.17l-.42.24c-2.47,1.41-5.61.58-7.06-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m256.87,440.11l-20.3-34.19,9.45-5.41,20.21,34.05c1.48,2.5.63,5.73-1.89,7.17l-.42.24c-2.47,1.41-5.61.58-7.06-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m243.33,438.63l-20.3-34.19,9.45-5.41,20.21,34.05c1.48,2.5.63,5.73-1.89,7.17l-.42.24c-2.47,1.41-5.61.58-7.06-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m167.13,292.15h0c13.07-7.48,29.36-3.96,36.38,7.86l53.32,76.02-37.77,21.62-62.89-70.54c-7.02-11.82-2.11-27.47,10.96-34.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "274.32 428.52 263.55 410.36 265.03 409.48 275.8 427.64 274.32 428.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "265.95 435.9 253.58 414.93 255.07 414.05 267.44 435.03 265.95 435.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "252.12 433.79 244.13 420.34 245.61 419.46 253.6 432.91 252.12 433.79"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.52 191.31 313.03 175.45 314.68 155.93 360.97 170.99 360.52 191.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 359.62,
    y: 174.04,
    width: 2.71,
    height: 14.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 324.36,
    y: 164.73,
    width: 2.71,
    height: 25.67,
    transform: "translate(63.05 439.54) rotate(-73.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 421.72,
    y: 350.8,
    width: 2.71,
    height: 44.71
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m440.92,448.64c1.25-12.19-1.72-23.7-2.4-26.12,0,0,0,0,0,0,0,0,0,0,0,0-.07-.24-.12-.43-.14-.47-.03-.11-.09-.21-.13-.32-.91-2.71-2.63-5.32-3.66-6.73l.67-.19-15.5-59.25v-4.76h-1.24l-.69-2.63v-109.09c0-32.08-21.26-58.69-49.23-64.09,30.53,5.4,53.73,32.01,53.73,64.09v109.09l.75,2.63h1.36v4.76l16.92,59.25-.73.19c1.13,1.41,3,4.01,3.99,6.73.04.11.11.21.14.32.02.05.07.23.15.47,0,0,0,0,0,0,0,0,0,0,0,0,.74,2.42,3.99,13.93,2.62,26.12-1.66,14.75-13.95,22.53-14.47,22.85-.84.52-1.76.76-2.68.76s-1.82-.34-2.62-.83c1.07-.74,11.68-8.46,13.16-22.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m340.09,85.35c-24.33,6.84-21.07,36.78-21.07,36.78l.58.51c-1.53,3.17-1.17,7.92,1.22,12.13,2.1,3.7,5.25,6.01,8.21,6.47v.02c-.34-.03-.59-.07-.6-.07l-.27,1.76s.22.04.51.07l-3.08,15.19-3.64-1.29,3.08-13.9c-.32-.03-.53-.07-.55-.07l.29-1.76s.29.04.65.07v-.02c-3.23-.45-6.66-2.76-8.96-6.47-2.61-4.21-3-8.96-1.34-12.13l-.63-.51s-3.56-29.94,22.99-36.78c5.22-1.34,9.76-1.81,13.74-1.69-3.29.03-6.97.52-11.13,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m378.78,162.83c-2.54,1.62-5.64,2.34-9.02,2.43,3.06-.11,5.87-.83,8.17-2.43,12.81-8.91,4.53-32.92,4.53-32.92,0,0,.01.07.03.19l-3.21-17.27c-.08-.5-.17-1-.28-1.49l-.13-.7h-.04c-1.04-4.44-2.93-8.51-5.52-11.94,0-1.94-1.45-5.56-4.73-8.77,3.57,3.21,5.17,6.83,5.16,8.77,2.83,3.43,4.89,7.5,6.03,11.94h.04s.14.71.14.71c.11.49.21.99.3,1.49l3.5,17.27c-.02-.12-.04-.19-.04-.19,0,0,9.04,24.01-4.94,32.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m368.59,165.25c-2.76-.03-5.67-.44-8.6-1.11l.03-.16c2.92.77,5.82,1.24,8.56,1.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "258.34 363.82 248.27 348.14 248.27 293.61 258.34 283.9 258.34 363.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m411.76,469.74c.76-.04,1.53-.26,2.22-.73.12-.08.92-.64,2.08-1.65.12.47.27.93.52,1.37.16.27.35.5.55.73-.47.16-.94.26-1.43.29.04,2.48.07,4.97.1,7.45h-3.95c-.03-2.49-.06-4.97-.09-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m245.81,440.76c-1-.42-1.89-1.13-2.48-2.13l-20.3-34.19.05-.03-4.02-6.77-62.89-70.54c-2.87-4.83-3.71-10.3-2.85-15.6-1.36-8.67,1.57-17.84,8.62-24.09l80.48-71.13,14.09-12.43c1.35-1.2,2.8-2.21,4.3-3.08,11.8-16.18,30.82-26.75,52.36-26.83l1.52-18.01,4.4,1.43-1.28,16.58c-19.73.08-37.16,10.65-47.98,26.83-1.38.87-2.7,1.88-3.94,3.08l-12.91,12.43-73.74,71.13c-6.46,6.25-9.14,15.42-7.89,24.09-.79,5.29-.01,10.76,2.62,15.6l57.62,70.54,3.68,6.77-.05.03,18.6,34.19c.55,1,1.36,1.71,2.27,2.13-.7,10.85-1.38,23.19-2.02,36.43h-10.46c.7-13.24,1.44-25.57,2.2-36.43Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "392.17 457.37 460.48 612.27 827.78 531.18 827.78 306.56 392.17 457.37"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 414.7,
    cy: 536.35,
    r: 84.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m335.59,648.68l81.13-34.01c25.57-10.72,37.61-40.13,26.89-65.7l-40.65-96.98-127.43,53.41,60.05,143.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m222.34,569.87l143.97-60.35-15.03-35.86-143.97,60.35c-9.9,4.15-14.57,15.55-10.42,25.45h0c4.15,9.9,15.55,14.57,25.45,10.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m218.73,613.55l143.97-60.35-15.03-35.86-143.97,60.35c-9.9,4.15-14.57,15.55-10.42,25.45h0c4.15,9.9,15.55,14.57,25.45,10.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m246.81,643.95l143.97-60.35-15.03-35.86-143.97,60.35c-9.9,4.15-14.57,15.55-10.42,25.45h0c4.15,9.9,15.55,14.57,25.45,10.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m290.74,667.7l143.97-60.35-15.03-35.86-143.97,60.35c-9.9,4.15-14.57,15.55-10.42,25.45h0c4.15,9.9,15.55,14.57,25.45,10.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 219.13,
    y: 550.69,
    width: 82.58,
    height: 6.44,
    transform: "translate(-193.89 143.74) rotate(-22.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 225.61,
    y: 587.63,
    width: 95.24,
    height: 6.44,
    transform: "translate(-208.31 152.81) rotate(-22.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 273.33,
    y: 616.79,
    width: 61.18,
    height: 6.44,
    transform: "translate(-216.06 165.69) rotate(-22.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 314.46,
    y: 525.74,
    width: 6.45,
    height: 102.68,
    transform: "translate(-218.25 194.04) rotate(-25.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m325.96,484.27l7.64,18.23c13.03,31.09,48.92,45.77,80.01,32.74l36.47-15.29-2.49-5.94-36.47,15.29c-27.82,11.66-59.92-1.48-71.58-29.29l-7.64-18.23-5.94,2.49Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 353.4,
    y: 548.86,
    width: 6.45,
    height: 87.58,
    transform: "translate(-217.96 207.6) rotate(-25.14)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "312.59 638.89 194.38 594.34 251.57 449.62 369.77 494.18 312.59 638.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m418.25,554.07l-133.05-50.15,14.31-36.23,132.5,49.94c9.72,3.66,14.56,14.58,10.74,24.25l-.64,1.61c-3.73,9.45-14.36,14.16-23.87,10.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m421.23,596.81l-133.05-50.15,14.31-36.23,132.5,49.94c9.72,3.66,14.56,14.58,10.74,24.25l-.64,1.61c-3.73,9.45-14.36,14.16-23.87,10.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m394.81,628.48l-133.05-50.15,14.31-36.23,132.5,49.94c9.72,3.66,14.56,14.58,10.74,24.25l-.64,1.61c-3.73,9.45-14.36,14.16-23.87,10.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m353.7,654.6l-133.05-50.15,14.31-36.23,132.5,49.94c9.72,3.66,14.56,14.58,10.74,24.25l-.64,1.61c-3.73,9.45-14.36,14.16-23.87,10.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "251.57 449.62 -155.42 339.23 -155.42 531.46 194.38 594.34 251.57 449.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "417.67 557.14 347.02 530.51 349.18 524.74 419.83 551.37 417.67 557.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "410.78 596.45 329.39 565.5 331.59 559.74 412.98 590.68 410.78 596.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "367.43 621.44 315.09 601.72 317.25 595.95 369.59 615.68 367.43 621.44"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m305.68,538.5h0c-5.43-9.34-2.26-21.31,7.08-26.73l79.23-46.06c9.34-5.43,21.31-2.26,26.73,7.08h0c5.43,9.34,2.26,21.31-7.08,26.73l-79.23,46.06c-9.34,5.43-21.31,2.26-26.73-7.08Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m299.15,229.52c-.03,1.25.21,2.43.78,3.55,2.84,5.51,5.67,11.02,8.51,16.54.6,1.16,1.16,2.34,1.8,3.47,1.09,1.95,3.14,1.97,4.3.07.08-.14.16-.28.23-.42,1.06-2.03,2.16-4.04,3.16-6.09,1.06-2.18,1.14-4.48.07-6.65-2.36-4.77-4.81-9.49-7.3-14.2-1.46-2.75-4.61-3.97-7.24-2.95-2.67,1.03-4.31,3.57-4.31,6.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m327.79,225.87c-1.29,2.62-2.58,5.24-3.87,7.86-.6,1.22-1.19,2.45-1.8,3.66-.45.9-1.09,1.6-2.18,1.64-1.09.04-1.78-.61-2.27-1.5-1.09-1.96-2.19-3.9-3.22-5.89-.82-1.59-1.01-3.31-.69-5.07.38-2.14,2.55-3.99,4.85-4.07,2.26-.07,4.53-.04,6.79-.02,1.21,0,1.9.77,2.39,1.78,0,0,.32.8,0,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m299.14,229.52c0-3.11,1.65-5.65,4.31-6.68,2.64-1.02,5.78.2,7.24,2.95,2.49,4.7,4.94,9.43,7.3,14.2,1.07,2.16.99,4.46-.07,6.65-1,2.06-2.1,4.06-3.16,6.09-.07.14-.15.28-.23.42-1.16,1.91-3.21,1.89-4.3-.07-.64-1.14-1.2-2.31-1.8-3.47-2.84-5.51-5.67-11.03-8.51-16.54-.57-1.12-.82-2.3-.78-3.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 312.77,
    cy: 215.02,
    r: 7.44
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePeople);
export default __webpack_public_path__ + "static/media/home-people.2897a954c6ef3f18ff6c9622afe2c7fb.svg";
export { ForwardRef as ReactComponent };